import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useChipContext } from '../../context.mjs';
import { chipValue, chipValueHorizontalGap } from './value.vanilla.mjs';

const ChipValue = forwardRef(
  ({ className: classNameFromProps, space, style: styleFromProps, ...props }, forwardedRef) => {
    const { state } = useChipContext("Chip.Value");
    const className = classNames(chipValue, classNameFromProps);
    const styles = Object.assign(
      {},
      assignInlineVars({
        [chipValueHorizontalGap]: space !== void 0 ? `${space}px` : null
      }),
      styleFromProps
    );
    return /* @__PURE__ */ jsx(
      StyledDiv,
      {
        "data-scope": "chip",
        "data-part": "value",
        "data-chip-state": state,
        className,
        style: styles,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const StyledDiv = styled(Primitive.div);
ChipValue.displayName = "Chip.Value";

export { ChipValue };
//# sourceMappingURL=Value.mjs.map
